import { Component,  ElementRef, HostListener, ViewChild  } from '@angular/core';
import { Router } from '@angular/router';
import { User, UserService } from '../../core/services/user.service';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { TimesheetService } from '../../core/services/timesheet.service';
import { LoginService } from '../../core/services/login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {


  isPopupVisible = false;
  isReportPopupVisible = false;
  mobileMenuOpen = false;

  userName: string |null = 'Guest';
  userRole: string=' ';
  isUserWithoutSSO:any='false';
  userNameWithoutSSO:any='';


  @ViewChild('popupContent') popupContent!: ElementRef;
  @ViewChild('popupTrigger') popupTrigger!: ElementRef;

  @ViewChild('reportPopupContent') reportPopupContent!: ElementRef;
  @ViewChild('reportPopupTrigger') reportPopupTrigger!: ElementRef;

  constructor(public router: Router,private msalService: MsalService,private timesheetService: TimesheetService,private loginService: LoginService) {}

  ngOnInit(): void {

      this.loginService.username$.subscribe(name => this.userName = name);
      this.loginService.loadFromStorage(); 
  }

  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
    this.isReportPopupVisible = false;
  }

  toggleReportPopup() {
    this.isReportPopupVisible = !this.isReportPopupVisible;
    this.isPopupVisible = false;
  }

  isLoggedIn(): boolean {
    return localStorage.getItem('isLoggedIn') === 'true';
  }

  logoutUser(): void {
    this.clearLocalStorage();

    // Clear MSAL cache if it exists
    if (this.msalService?.instance) {
      const accounts = this.msalService.instance.getAllAccounts();
      accounts.forEach(account => {
        this.msalService.instance.clearCache({
          account: account
        });
      });
    }

    // Navigate to user login page
    this.router.navigate(['/Login']);
  }

  logoutAdmin(): void {
    this.clearLocalStorage();

    // Clear MSAL cache if it exists
    if (this.msalService?.instance) {
      const accounts = this.msalService.instance.getAllAccounts();
      accounts.forEach(account => {
        this.msalService.instance.clearCache({
          account: account
        });
      });
    }

    // Navigate to admin login page
    this.router.navigate(['/admin/login']);
  }

  clearLocalStorage(): void {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginType');
    localStorage.removeItem('userNameWithoutSSO');
    localStorage.removeItem('isUserWithoutSSO');
    localStorage.removeItem('NTID');
    localStorage.removeItem('emailWithoutSSO');
    localStorage.removeItem('admin_token');
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  async loadUserProfile(): Promise<void> {
    try {
      let account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const allAccounts = this.msalService.instance.getAllAccounts();
        if (allAccounts.length > 0) {
          account = allAccounts[0];
          this.msalService.instance.setActiveAccount(account);
        }
      }
  
      let accessToken: string | null = null;
      if (account) {
        try {
          const silentResult = await this.msalService.instance.acquireTokenSilent({
            account,
            scopes: ['User.Read']  
          });
          accessToken = silentResult.accessToken;
        } catch (silentErr) {
          console.warn('Silent token failed, falling back to popup.', silentErr);
        }
      }
  
      if (!accessToken) {
        const popupResult = await firstValueFrom(
          this.msalService.loginPopup({
            scopes: ['User.Read']
          })
        );
        this.msalService.instance.setActiveAccount(popupResult.account);
        const tokenResult = await this.msalService.instance.acquireTokenSilent({
          account: popupResult.account,
          scopes: ['User.Read']
        });
        accessToken = tokenResult.accessToken;
      }
  
      if (accessToken) {
        const profileResponse  = await this.timesheetService.getUserProfile(accessToken);
        const profile = JSON.parse(profileResponse.body);

            this.userName = profile.displayName;
            this.userRole=   profile.jobTitle;
      }
    } catch (err) {
      console.error('Error loading user profile:', err);
    }
  }
  

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsidePopup = this.popupContent?.nativeElement.contains(event.target);
    const clickedTrigger = this.popupTrigger?.nativeElement.contains(event.target);

    const clickedInsideReportPopup = this.reportPopupContent?.nativeElement.contains(event.target);
    const clickedReportTrigger = this.reportPopupTrigger?.nativeElement.contains(event.target);

    if (!clickedInsidePopup && !clickedTrigger) {
      this.isPopupVisible = false;
    }
    if (!clickedInsideReportPopup && !clickedReportTrigger) {
      this.isReportPopupVisible = false;
    }
  }
}
